{
  "nav": {
    "dashboard": "Dashboard",
    "teacherDashboard": "My Sessions",
    "projects": "Projects",
    "fairQuote": "Fair Quote",
    "exitFairQuote": "Exit Fair Quote",
    "contacts": "Contacts",
    "entities": "Entities",
    "products": "Products",
    "colors": "Colors",
    "courses": "Courses",
    "teachers": "Teachers",
    "students": "Students",
    "certifications": "Certifications",
    "staff": "Staff",
    "company": "My company",
    "overview": "Overview",
    "sections": {
      "projects": "Projects",
      "shop": "Shop & Catalogue",
      "entity": "Entity workspace",
      "learning": "Learning",
      "admin": "Administration"
    },
    "enrollments": "Enrollments",
    "calendar": "Calendar",
    "userManagement": "User Management",
    "applicatorProfiles": "Applicator Profiles",
    "certificationDefinitions": "Certification Definitions",
    "switchEntity": "Switch entity"
  }
}
